export const COMMUNITY_DASHBOARD_FILTER_TYPE = {
  PROFILE_TAG: 'PROFILE_TAG',
  USER_PROPERTY: 'USER_PROPERTY',
  COMMUNITY: 'COMMUNITY'
};

export const COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES = {
  [COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG]: 'Profiling tag',
  [COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY]: 'User property',
  [COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY]: 'Community'
};

export const USER_PROPERTIES = {
  LANGUAGE: 'LANGUAGE',
  GENDER: 'GENDER',
  AGE: 'AGE',
  COUNTRY: 'COUNTRY',
  SURROUNDINGS: 'SURROUNDINGS',
  PROVINCE: 'PROVINCE',
  POSTAL_CODE: 'POSTAL_CODE',
  PLACE: 'PLACE',
  CIVIL_STATUS: 'CIVIL_STATUS',
  CHILDREN: 'CHILDREN',
  LIVING_ARRANGEMENT: 'LIVING_ARRANGEMENT',
  DEGREE: 'DEGREE',
  MAIN_ACTIVITY: 'MAIN_ACTIVITY',
  FUNCTION: 'FUNCTION',
  SECTOR: 'SECTOR',
  BETA_TESTER: 'BETA_TESTER',
  SIGNED_UP_THROUGH: 'SIGNED_UP_THROUGH',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION'
};

export const USER_PROPERTY_NAMES = {
  LANGUAGE: 'Language',
  GENDER: 'Gender',
  AGE: 'Age',
  COUNTRY: 'Country',
  SURROUNDINGS: 'Surroundings',
  PROVINCE: 'Province',
  POSTAL_CODE: 'Postal code',
  PLACE: 'Place',
  CIVIL_STATUS: 'Civil status',
  CHILDREN: 'Children',
  LIVING_ARRANGEMENT: 'Living arrangement',
  DEGREE: 'Degree',
  MAIN_ACTIVITY: 'Main activity',
  FUNCTION: 'Function',
  SECTOR: 'Sector',
  BETA_TESTER: 'Beta tester',
  SIGNED_UP_THROUGH: 'Signed up through',
  PENDING_ACTIVATION: 'Pending activation'
};

export const AGE_RANGES = {
  BELLOW_18: 'BELLOW_18',
  '18_24': '18_24',
  '25_34': '25_34',
  '35_44': '35_44',
  '45_54': '45_54',
  '55_64': '55_64',
  ABOVE_65: 'ABOVE_65'
};

export const AGE_RANGE_NAMES = {
  [AGE_RANGES.BELLOW_18]: '< 18 years old',
  [AGE_RANGES['18_24']]: '18 - 24 years old',
  [AGE_RANGES['25_34']]: '25 - 34 years old',
  [AGE_RANGES['35_44']]: '35 - 44 years old',
  [AGE_RANGES['45_54']]: '45 - 54 years old',
  [AGE_RANGES['55_64']]: '55 - 64 years old',
  [AGE_RANGES.ABOVE_65]: '> 65 years old'
};

export const FILTER_RELATIONS = {
  AND: 'AND',
  OR: 'OR'
};

export const FILTER_RANGES = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};

export const FILTER_RANGE_LABELS = {
  [FILTER_RANGES.DAY]: 'Daily',
  [FILTER_RANGES.WEEK]: 'Weekly',
  [FILTER_RANGES.MONTH]: 'Monthly',
  [FILTER_RANGES.YEAR]: 'Yearly'
};

export const MAIN_DATA_METRICS = {
  ACTIVE_USERS: 'activeUsers',
  RESPONSE_RATE: 'responseRate',
  COMMUNITY_SIZE: 'communitySize',
  MAXIMUM_DELIVERY_POTENTIAL: 'maximumDeliveryPotential'
};
